'use strict';

window.SlamJam = window.SlamJam || {};

SlamJam.minicart = function () {
  var settings = {
    openMinicartSelector: '.menu-utility__item--cart, .minicart',
    minicartSelector: '.minicart',
    minicartContainer: '.minicart__container',
    minicartContent: '.minicart__content',
    minicartItemRemove: '.minicart__item-remove',
    minicartTotals: '.minicart__totals',
    minicartTotal: '.minicart__totals .total',
    minicartClose: '.minicart__close',
    minicartCounter: '.minicart__count',
    moneyFormat: $('body').data('money-format'),
    triggeredOpenMinicart: false,
    //Label che contengoni le q.ta totali nel carrello, aggiornate dopo l'aggiunta di un elemento al carrello
    totalItemsLabel: '.cart-total-items'
  };

  function init() {
    initMinicart();
  }

  function initMinicart() {
    _buildMinicart();

    if (!SlamJam.isMobile(1024)) {
      $(settings.openMinicartSelector).hoverIntent({
        timeout: 160,
        interval: 60,
        over: function over() {
          if (!canShowMiniCart()) return false;
          $(settings.minicartContent).scrollTop(0);
          HideMinicartIfShopByLookVisible();
        },
        out: function out() {
          if (!$(settings.minicartSelector).is(':hover')) {
            $(settings.minicartContent).scrollTop(0);
            $(settings.minicartSelector).removeClass('visible');
          }
        }
      });

      $('body').on('click', settings.minicartItemRemove, function () {
        var line = $(this).closest('.minicart__item').data('line');
        if (gtmEnabled != false) {
          trackGtmInfoRemoveItemMinicart($(this));
        }
        _removeItem(line);
      });
    } else {
      $('body').on('click', settings.minicartClose, function () {
        closeMinicart();
      });
    }
  }

  function HideMinicartIfShopByLookVisible() {
    if (template == 'product') {
      if (SlamJam.strings.dropInstance == false) {
        if (!$('.shop-by-look-products').hasClass('visible')) {
          $(settings.minicartSelector).addClass('visible');
        }
      } else {
        $(settings.minicartSelector).addClass('visible');
      }
    } else {
      $(settings.minicartSelector).addClass('visible');
    }
  }

  function canShowMiniCart() {
    return !$(settings.minicartSelector).hasClass('empty');
  }

  /**
   * Avvia l'apertura del minicart
   * * Solo se ci sono elementi nel carrello
   *
   */
  function openMinicart() {
    if (!canShowMiniCart()) return false;

    //[PIM-1771]
    //refreshMinicart();
    $(settings.minicartContent).scrollTop(0);

    if (SlamJam.isMobile(1024)) {
      $(settings.minicartSelector).insertAfter('.overlay');
      $('.overlay').addClass('visible');
    }

    settings.triggeredOpenMinicart = true;
    $(settings.minicartSelector).addClass('visible');

    //Chiudo il minicart dopo 5 secondi
    var timeoutMinicart = setTimeout(function () {
      settings.triggeredOpenMinicart = false;
      closeMinicart();
    }, 5000);

    //Blocco il timeout se l'utente sta utilizzando il minicart
    $(document).on('touchstart mouseover', '.minicart__content', function () {
      clearTimeout(timeoutMinicart);
    });

    settings.triggeredOpenMinicart = false;
  }

  function closeMinicart() {
    $(settings.minicartSelector).removeClass('visible');

    if (SlamJam.isMobile(1024)) {
      $('.overlay').removeClass('visible');
    }
  }

  /**
   * Crea l'html del prezzo nel minicart comparando quello del prodotto con quello inserito a carrello
   *
   *
   * @param {*} product Oggetto Product.js (Ottenuto da eventuali chiamate ajax)
   * @param {*} item Oggetto item on cart
   */
  function getItemPriceHTML(product, item) {
    // Ricerca la variante del prodotto inserito a carrello
    product.variants.forEach(function (variant) {
      if (variant.id == item.variant_id) {
        if (variant.compare_at_price != null) {
          item["compare_at_price"] = Shopify.formatMoney(variant.compare_at_price, SlamJam.settings.moneyFormat);
        } else {
          item["compare_at_price"] = null;
        }
      }
    });

    var price_html = _getItemPriceHTML(item);

    return price_html;
  }

  function _getItemPriceHTML(item) {
    var price_html = '';

    if (item.discountsApplied) {
      price_html = '<span class="was_price">' + item.compare_at_price + '</span>&nbsp;&nbsp;<span class="price">' + item.price + '</span>';
    } else if (item.compare_at_price && item.compare_at_price != Shopify.formatMoney(0, SlamJam.settings.moneyFormat) && item.compare_at_price != item.price) {
      price_html = '<span class="was_price">' + item.compare_at_price + '</span>&nbsp;&nbsp;<span class="price">' + item.price + '</span>';
    } else {
      price_html = '\n          <span class="price">' + item.price + '</span>';
    }

    return price_html;
  }

  /**
   * Crea l'html per le alert
   * @param {*} itemAlerts
   */
  function getItemAlertHtml(itemAlerts) {
    var item_html = '';
    item_html = item_html + '<div class="minicart__item-alerts">';

    if (itemAlerts['exp']) {
      item_html = item_html + '<div class="minicart__item-alerts__alert">' + SlamJam.strings.minicart.alerts.preorder_exp_delivery_date + ' ' + itemAlerts['exp'] + '</div>';
    }

    item_html = item_html + '</div>';

    return item_html;
  }

  /**
   * Aggiunge informazioni aggiuntive al prodotto
   *  * il prezzo scontato, tramite chiamte Ajax per ogni elemento del carrello
   *  * gli alerts (Es delivery date)
   *
   * @param {*} item
   */

  function addExtraInfoFromProduct(item) {
    var self = this;
    /*if (SlamJam.settings.miniCart.add_compare_at_price !== true) {
      cart.items.forEach(function(item) {
        item["compare_at_price"] = null;
      });
    }  else {
      */
    item['alerts'] = [];

    $.ajax({
      url: '/products/' + item.handle + '.js',
      dataType: 'json',
      async: true
    }).then(function (product) {
      var defaultSizeScale = false;
      var expectedDeliveryDate = false;
      var isPreorder = false;
      var dt = new Date();
      // Ottine l'html del prezzo
      var price_html = getItemPriceHTML(product, item);
      // Aggiunge l'html del prezzo aggiornato al DOM
      var objItem = $('#cart_item_' + item.line);
      objItem.find('.minicart__item-price').html(SlamJam.strings.minicart_item_unitPrice + price_html);

      // Crea gli alert del prodotto
      for (var jj = 0; jj < product.tags.length; jj++) {
        var data = product.tags[jj].split('_');

        if (data[0] == 'exp') {
          expectedDeliveryDate = data[1];
        } else if (data[0] == 'countrysize-map' && data[1] != 'JP') {
          defaultSizeScale = data[1];
        } else if (data[0] == 'preorder' && data[1] == '1') {
          isPreorder = true;
        }
      }

      if (isPreorder && expectedDeliveryDate) {
        item['alerts']['exp'] = expectedDeliveryDate;
      }

      var htmlAlters = getItemAlertHtml(item['alerts']);

      // se ho il default size scale aggiungo la scala taglia
      if (defaultSizeScale) {
        var html = objItem.find('.minicart__item-option.minicart__item-size__span').html();

        html = defaultSizeScale.toUpperCase() + ' ' + html;
        objItem.find('.minicart__item-option.minicart__item-size__span').html(html);
      }

      if (objItem.find('.minicart__item-alerts').length > 0) {
        objItem.find('.minicart__item-alerts').html(htmlAlters);
      } else {
        objItem.find('.minicart__item-info').append($('<div clas="minicart__item-alerts-wrapper"></div>').html(htmlAlters));
      }
    }, function (e) {
      console.warn('Minicart addExtraInfoFromProduct error', e);
    });
  }

  /**
   * Dopo aver inviato la richiesta AJAX per ottenere il carrello, costruisco gli elementi del minicart
   */
  function _buildMinicart() {
    var items = [];
    var productInfo = null;

    $('body').trigger('show-loading', { handle: 'minicart-loading' });

    //Elimino il contentuo del minicart e lo nascondo
    $(settings.minicartContent).empty();
    $(settings.minicartContainer).hide();

    $.getJSON('/cart.js', function (_cart, textStatus) {
      $(settings.totalItemsLabel).text(_cart.item_count);

      // Non esegue nessuna azione aggiuntiva se è nascosta l'header
      if (SlamJam.isMobile(SlamJam.costants.grid_large, false)) {
        return;
      }

      // Show empty cart
      if (_cart.item_count === 0) {
        $(settings.minicartSelector).addClass('empty');
        $(settings.minicartContent).append('');
        return;
      }

      //Add Compare at price for all item in cart
      //let cart = addExtraInfoFromProduct(_cart);
      var cart = _cart;

      $(settings.minicartSelector).removeClass('empty');

      var itemsInCart = [];
      itemsInCart = cart.items;

      // Add each item to minicart
      $.each(itemsInCart, function (index, cartItem) {
        productInfo = null;
        cartItem["alerts"] = []; //Alert articolo da popolare con chimata ajax

        var prodImg = '';
        var abTest = false;

        var firstImageGroupOne = false;
        var secondImageGroupOne = false;
        var thirthImageGroupOne = false;

        var firstImageGroupTwo = false;
        var secondImageGroupTwo = false;
        var thirthImageGroupTwo = false;

        var groupOne = false;
        var groupTwo = false;
        var metafieldInfos = false;

        $.ajax({
          url: '/products/' + cartItem.handle + '.js',
          dataType: 'json',
          async: false,
          success: function success(response) {

            for (var i = 0; i < response.images.length; i++) {

              if (response.images[i].includes("_00") == true) {
                firstImageGroupOne = response.images[i];
              }

              if (response.images[i].includes("_01") == true) {
                secondImageGroupOne = response.images[i];
              }

              if (response.images[i].includes("_02") == true) {
                thirthImageGroupOne = response.images[i];
              }

              if (response.images[i].includes("_20") == true) {
                firstImageGroupTwo = response.images[i];
              }

              if (response.images[i].includes("_21") == true) {
                secondImageGroupTwo = response.images[i];
              }

              if (response.images[i].includes("_22") == true) {
                thirthImageGroupTwo = response.images[i];
              }
            }

            if (firstImageGroupOne != false) {
              groupOne = firstImageGroupOne;
            } else if (secondImageGroupOne != false) {
              groupOne = secondImageGroupOne;
            } else if (thirthImageGroupOne != false) {
              groupOne = thirthImageGroupOne;
            }

            if (firstImageGroupTwo != false) {
              groupTwo = firstImageGroupTwo;
            } else if (secondImageGroupTwo != false) {
              groupTwo = secondImageGroupTwo;
            } else if (thirthImageGroupTwo != false) {
              groupTwo = thirthImageGroupTwo;
            }

            for (var _i = 0; _i < response.tags.length; _i++) {
              if (response.tags[_i] == 'product_ab-test') {
                abTest = true;
              }
            }
          }
        });

        if (abTest == true) {

          var groupAB = localStorage.getItem("ab-localization");

          if (groupAB = 'groupB') {
            prodImg = groupTwo.replace(/(\.[^.]*)$/, "_250x$1").replace('http:', '');
          } else {
            prodImg = groupOne.replace(/(\.[^.]*)$/, "_250x$1").replace('http:', '');
          }
        } else {
          if (cartItem.image != null) {
            prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_250x$1").replace('http:', '');
          } else {
            prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
          }
        }

        if (cartItem.properties !== null) {
          $.each(cartItem.properties, function (key, value) {
            if (key.charAt(0) === '_' || !value) {
              delete cartItem.properties[key];
            }
          });
        }

        if (cartItem.line_level_discount_allocations.size !== 0) {
          for (var discount in cartItem.line_level_discount_allocations) {
            var amount = cartItem.line_level_discount_allocations[discount].amount;
            cartItem.line_level_discount_allocations[discount].formattedAmount = Shopify.formatMoney(amount, SlamJam.settings.moneyFormat);
          }
        }

        if (cart.cart_level_discount_applications.size !== 0) {
          for (var discount in cart.cart_level_discount_applications) {
            var amount = cart.cart_level_discount_applications[discount].total_allocated_amount;
            cart.cart_level_discount_applications[discount].formattedAmount = Shopify.formatMoney(amount, SlamJam.settings.moneyFormat);
          }
        }

        // ottengo i metafield
        $.ajax({
          url: '/products/' + cartItem.handle + '?view=metafield',
          async: false,
          success: function success(response) {
            metafieldInfos = JSON.parse(response);
          }

        });

        // Create item's data object and add to 'items' array
        var item = {
          itemVynilName: metafieldInfos.product_vinyl_vendor,
          itemVynil: metafieldInfos.product_vinyl_match,
          abTest: abTest,
          handle: cartItem.handle,
          key: cartItem.key,
          line: index + 1, // Shopify uses a 1+ index in the API
          url: cartItem.url,
          img: prodImg,
          name: cartItem.product_title,
          variation: cartItem.variant_title ? cartItem.variant_title : null,
          properties: cartItem.properties,
          itemAdd: cartItem.quantity + 1,
          itemMinus: cartItem.quantity - 1,
          itemQty: cartItem.quantity ? cartItem.quantity : null,
          price: cartItem.price ? Shopify.formatMoney(cartItem.price, SlamJam.settings.moneyFormat) : null,
          gtmPrice: (cartItem.price / 100).toFixed(2),
          gtmId: cartItem.sku.split("-")[0],
          gtmRealPrice: cartItem.compare_at_price ? (cartItem.compare_at_price / 100).toFixed(2) : (cartItem.price / 100).toFixed(2),
          gtmIsSales: cartItem.compare_at_price > cartItem.price ? 'yes' : 'no',
          compare_at_price: cartItem.compare_at_price ? Shopify.formatMoney(cartItem.compare_at_price, SlamJam.settings.moneyFormat) : null,
          vendor: cartItem.vendor,
          linePrice: Shopify.formatMoney(cartItem.final_line_price, SlamJam.settings.moneyFormat),
          originalLinePrice: Shopify.formatMoney(cartItem.original_line_price, SlamJam.settings.moneyFormat),
          discounts: cartItem.line_level_discount_allocations,
          discountsApplied: cartItem.line_level_discount_allocations.length === 0 ? false : true,
          variants: cartItem.variants || null,
          options_with_values: cartItem.options_with_values || [],
          alerts: cartItem.alerts,
          variant_id: cartItem.variant_id,
          giftCard: cartItem.gift_card
        };

        // Aggiungo l'elemento Riga del minicart
        items.push(item);
        _writeMinicartItem(item);

        //Aggiunge in Ajax Async le info necessarie come prezzo ed alert....
        addExtraInfoFromProduct(item);
      });

      $(settings.minicartContainer).show();
      _writeMinicartTotal(Shopify.formatMoney(cart.total_price, SlamJam.settings.moneyFormat));
      $(settings.minicartCounter).text(cart.item_count);
    });
  }

  function _writeMinicartItem(item) {
    // price markup
    var price_html = _getItemPriceHTML(item);
    var itemVendor = false;

    if (item.itemVynilName != '' && item.itemVynil == true) {
      itemVendor = item.itemVynilName;
    } else {

      itemVendor = item.vendor;
    }

    var remove_html = '\n        <div class="minicart__item-remove">\n          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 8.485 8.485">\n            <defs>\n              <clipPath id="a">\n                <rect class="a" width="8.485" height="8.485"/>\n              </clipPath>\n            </defs>\n            <g class="b">\n              <rect width="11" height="1" transform="translate(7.778 8.485) rotate(-135)"/>\n              <rect width="11" height="1" transform="translate(0 7.778) rotate(-45)"/>\n            </g>\n          </svg>\n        </div>\n      ';

    var item_html = '\n      <div class="minicart__item" color="' + (item.options_with_values[1] ? item.options_with_values[1].value : '') + '" data-line-handle="' + item.handle + '" data-line="' + item.line + '" data-variant="' + item.options_with_values[0].value + '" data-id="' + item.gtmId + '" data-name="' + item.name + '" data-price="' + item.gtmPrice + '" data-vendor="' + item.vendor + '" data-category="' + item.type + '" data-qty="' + item.itemQty + '" data-metric1="' + item.gtmRealPrice + '" data-dimension4="' + item.gtmIsSales + '" data-realPrice="' + item.compare_at_price + '" data-barcode="" data-line="' + item.line + '"  id="cart_item_' + item.line + '">\n          <div class="minicart__item-image"><a class="ratio-container" href="' + SlamJamMarkets.settings.currentUrlDomain + item.url + '"><img class="transition--fade-in lazyload" src="' + item.img + '"/></a></div>\n          <div class="minicart__item-info">\n            <div class="minicart__item-vendor">\n            ' + itemVendor + '\n            </div>\n            <div class="minicart__item-name">' + item.name + '</div>\n            <div class="minicart__item-price">' + SlamJam.strings.minicart_item_unitPrice + ' ' + price_html + '</div>';

    if (item.giftCard == false) {
      for (var i = 0; i < item.options_with_values.length; i++) {
        var className = 'minicart__item-option minicart__item-' + item.options_with_values[i].name.toLowerCase();
        var i18Nname = 'minicart_item_' + item.options_with_values[i].name.toLowerCase();
        item_html = item_html + ('<div class="' + className + '">' + SlamJam.strings[i18Nname] + ' <span class="' + className + '__span">' + item.options_with_values[i].value + '</span></div>');
      }
    }

    if (SlamJam.strings.dropInstance == false) {
      item_html = item_html + ('\n            <div class="minicart__item-qty">' + SlamJam.strings.minicart_item_quantity + ' ' + item.itemQty + '</div>\n            <div class="minicart__item-total">' + SlamJam.strings.minicart_item_total + ' ' + item.linePrice + '</div>');
      if (Object.keys(item.alerts).length > 0) {
        item_html = item_html + getItemAlertHtml(item.alerts);
      }
    } else {
      item_html = item_html + ('\n            <div class="minicart__item-total">' + SlamJam.strings.minicart_item_total + ' ' + item.linePrice + '</div>');
      if (Object.keys(item.alerts).length > 0) {
        item_html = item_html + getItemAlertHtml(item.alerts);
      }
    }

    item_html = item_html + '</div>';
    item_html = item_html + (remove_html + '\n        </div>\n      ');

    $('body').trigger('hide-loading', { handle: 'minicart-loading' });

    // Visualizzo il contenuto del minicart ed aggiungo l'elemento
    $(settings.minicartContainer).show();
    $(settings.minicartContent).append(item_html);
  }

  function _writeMinicartTotal(total_html) {
    $(settings.minicartTotal).text(total_html);
  }

  function _removeItem(line) {
    $('body').trigger('show-loading', { handle: 'minicart-loading' });

    setTimeout(function () {
      var productToRemove = {
        'quantity': 0,
        'line': line.toString()
      };

      SlamJam.Cart.changeItem(productToRemove, refreshMinicart);
    }, 250);
  }

  function refreshMinicart(cart) {
    setTimeout(function () {
      _buildMinicart();
    }, 150);
  };

  return {
    init: init,
    openMinicart: openMinicart,
    refreshMinicart: refreshMinicart,
    closeMinicart: closeMinicart
  };
}();